import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { Severity } from '../types';

// Alertコンポーネントをカスタマイズ
const Alert = React.forwardRef<HTMLDivElement, AlertProps>((props, ref) => {
  return <MuiAlert elevation={6} ref={ref} {...props} />;
});

interface CustomSnackbarProps {
  open: boolean;
  handleClose: () => void;
  severity: Severity;
  message: string;
}

const CustomSnackbar: React.FC<CustomSnackbarProps> = ({ open, handleClose, severity, message }) => {

  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={handleClose} severity={severity}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default CustomSnackbar;
